import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const GuestGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/questions-home" />;
  }

  return <>{children}</>;
};

export default GuestGuard;
